import React, { useEffect, useState } from 'react'
import getConfig from 'next/config'
import { sendNavigationInteractionEvent } from '@src/utils/analytics'
import { FooterLinks } from '@utils/analytics/enums'
import { makeStyles } from 'tss-react/mui'

const {
  publicRuntimeConfig: { cookieConsent, cookieDataDomainScript },
} = getConfig()

const useStyles = makeStyles()((theme) => {
  return {
    legalLinkSpacer: {
      padding: theme.spacing(0, 2),
      color: theme.palette.grey[400],
    },
    cookieLink: {
      cursor: 'pointer',
    },
  }
})

interface CookieFooterLinkProps {
  legalLinks: boolean
}

const CookieFooterLink: React.FC<CookieFooterLinkProps> = ({ legalLinks }) => {
  const { classes } = useStyles()
  const [text, setText] = useState('')

  useEffect(() => {
    try {
      const cookieDomain = window?.OneTrust?.GetDomainData?.()
      const text = cookieDomain?.CookieSettingButtonText
      setText(text)
    } catch (err) {
      console.error(
        'The application encountered an error getting cookie consent data.'
      )
      console.error(err)
    }
  }, []) // Run this effect only once when the component mounts

  if (!text) return null

  return (
    <>
      {cookieConsent && cookieDataDomainScript ? (
        <>
          {legalLinks && <span className={classes.legalLinkSpacer}>|</span>}
          {}
          <a
            className={`ot-sdk-show-settings ${classes.cookieLink}`}
            onClick={() => {
              sendNavigationInteractionEvent({
                action: 'footer click',
                detail: `${FooterLinks.TermsAndConditions} > Cookie Settings`,
                component: 'footer',
                elementType: 'link',
                elementText: text,
              })
            }}
          >
            {text}
          </a>
        </>
      ) : null}
    </>
  )
}

export default CookieFooterLink
